import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBoxes, faFileContract, faMapMarkedAlt, faTasks, faPercent, faCheckSquare } from '@fortawesome/free-solid-svg-icons';

const MiniDashboardItemCatalogue = ({
    totalItemNumbers,
    totalMxHts,
    totalUmc,
    totalUmf,
    percentageTlc,
    percentagePs
}) => {
  return (
    <div className="bg-white shadow rounded-lg p-3 w-full mb-4">
      <div className="grid grid-cols-6 divide-x divide-gray-200 text-center">
        <div className="flex flex-col items-center justify-center py-1">
          <FontAwesomeIcon icon={faBoxes} className="text-blue-600 text-2xl mb-1" />
          <p className="text-sm text-gray-600">Different Items</p>
          <p className="text-base font-semibold text-gray-800">{totalItemNumbers}</p>
        </div>
        <div className="flex flex-col items-center justify-center py-1">
          <FontAwesomeIcon icon={faMapMarkedAlt} className="text-green-600 text-2xl mb-1" />
          <p className="text-sm text-gray-600">Different MX HTS</p>
          <p className="text-base font-semibold text-gray-800">{totalMxHts}</p>
        </div>
        <div className="flex flex-col items-center justify-center py-1">
          <FontAwesomeIcon icon={faTasks} className="text-purple-600 text-2xl mb-1" />
          <p className="text-sm text-gray-600">Different UMC</p>
          <p className="text-base font-semibold text-gray-800">{totalUmc}</p>
        </div>
        <div className="flex flex-col items-center justify-center py-1">
          <FontAwesomeIcon icon={faFileContract} className="text-orange-600 text-2xl mb-1" />
          <p className="text-sm text-gray-600">Different UMF</p>
          <p className="text-base font-semibold text-gray-800">{totalUmf}</p>
        </div>
        <div className="flex flex-col items-center justify-center py-1">
          <FontAwesomeIcon icon={faPercent} className="text-teal-600 text-2xl mb-1" />
          <p className="text-sm text-gray-600">% TLC 'Y'</p>
          <p className="text-base font-semibold text-gray-800">{percentageTlc.toFixed(2)}%</p>
        </div>
        <div className="flex flex-col items-center justify-center py-1">
          <FontAwesomeIcon icon={faCheckSquare} className="text-indigo-600 text-2xl mb-1" />
          <p className="text-sm text-gray-600">% PS 'Y'</p>
          <p className="text-base font-semibold text-gray-800">{percentagePs.toFixed(2)}%</p>
        </div>
      </div>
    </div>
  );
};

export default MiniDashboardItemCatalogue;
